import React, { useRef, useState } from "react";
import Header from "../../Components/update/Header";
import Hero from "../../Components/update/Hero";
import About from "../../Components/update/About";
import Portfolio from "../../Components/update/Portfolio";
import Contact from "./Contact";
import Services from "../../Components/update/Services";
import Experience from "./Experince";

import "../../styles/update/main.css";
export default function Main() {
  const [portfolioRef, setPortfolioRef] = useState(null);
  const [aboutRef, setAboutRef] = useState(null);
  const [contactRef, setContactRef] = useState(null);
  const [servicesRef, setServicesRef] = useState(null);

  return (
    <div>
      <div className="initial">
        <Header
          aboutRef={aboutRef}
          portfolioRef={portfolioRef}
          servicesRef={servicesRef}
          contactRef={contactRef}
        />
        <Hero portfolioRef={portfolioRef} />
        <About setAboutRef={setAboutRef} />
        <Portfolio setPortfolioRef={setPortfolioRef} />
        <Services setServicesRef={setServicesRef} />
        <Experience />
      </div>
      <div>
        <Contact setContactRef={setContactRef} />
      </div>
      <div className="absolute inset-0 pointer-events-none bg-[linear-gradient(to_right,#80808012_1px,transparent_1px),linear-gradient(to_bottom,#80808012_1px,transparent_1px)] bg-[size:64px_64px]"></div>

      {/* <div className="absolute inset-0 bg-[linear-gradient(to_right,#80808012_1px,transparent_1px),linear-gradient(to_bottom,#80808012_1px,transparent_1px)] bg-[size:64px_64px]"></div> */}
    </div>
  );
}
